<template lang="pug">
  b-row
    b-col(sm='12')
      b-card(header="Object's details")
        b-row.pb-2
          b-col.d-none.d-sm-block(sm='2')
            .structure-logo(:class="structure.type + '-logo'")
          b-col(sm='10')
            h3 {{ structure.name }}
            strong.pr-2 Model:
            span {{ structure.model }}
            br
            strong.pr-2 Code:
            span {{ structure.code }}
            br
            strong.pr-2 Manufaturer:
            span {{ structure.manufacturer }}
            br
            strong.pr-2 Year of manufacture:
            span {{ structure.manufacture_year }}
            br
            strong.pr-2 Registered at:
            span {{ structure.created_at }}
      b-card(header='Past activities')
        c-index-table(
          :fields='checklistFields'
          initialEntity='checklist'
          :initialEntityParams='checklistParams'
        )
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import RouteGen from '@/utils/apiRoutes'
  import cIndexTable from '@/components/Shared/IndexTable.vue'

  export default {
    name: 'StructureShow',
    components: { cIndexTable },
    data () {
      return {
        structure: {},
        checklists: [],
        checklistFields: {
          id: { label: 'ID' },
          status: { label: 'Status' },
          name: { label: 'Name', sortable: true },
          project: { label: 'Project' },
          location: { label: 'Location' },
          date: { label: 'Date', sortable: true },
          checklist_show: { label: ' ' }
        },
        checklistParams: {
          per_page: 10,
          'q[structure_id_eq]': this.$route.params.id
        }
      }
    },
    mounted () {
      let currentPermissions = this.$route.meta.roles
      if (!Policeman.authorize(currentPermissions)) {
        this.showNotification(401)
        this.$route.push({ name: 'Home' })
      }
      this.fetchStructure(this.$route.params.id)
    },
    methods: {
      fetchStructure (structureId) {
        let currentPermissions = this.$route.meta.roles
        if (!Policeman.authorize(currentPermissions)) {
          this.showNotification(401)
          this.$route.push({ name: 'Home' })
        }
        let route = RouteGen.show('structure', structureId)
        server.get(route)
          .then(res => {
            this.$set(this.$data, 'structure', res.data.structure)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>

<style lang="sass">
  .structure-logo
    height: 6rem
    background:
      repeat: no-repeat
      size: contain
      position: 0 0
  .boat-logo
    background-image: url('/static/img/boat_icon.svg')
  .car-logo
    background-image: url('/static/img/car_icon.svg')
  .wind_turbine-logo
    background-image: url('/static/img/wind_turbine_icon.svg')
  .rig-logo
    background-image: url('/static/img/rig_icon.svg')
  .other-logo
    background-image: url('/static/img/other_icon.svg')
  .boom-logo
    background-image: url('/static/img/generic_structure_icon.svg')
  .shrouds-logo
    background-image: url('/static/img/generic_structure_icon.svg')
</style>



// WEBPACK FOOTER //
// src/components/Structure/Show.vue